module.exports = __webpack_public_path__ + "img/pc-button-large-03.cd5569d1.svg";